/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, code: NonNullable<unknown> }} Kiotviet_Link_Relink_ConfirmInputs */

const vi_kiotviet_link_relink_confirm = /** @type {(inputs: Kiotviet_Link_Relink_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sản phẩm này đang nối với ${i?.label}. Nối lại sẽ gỡ nối cũ; hoá đơn sau có mã ${i?.code} sẽ thành dòng chưa nối.`)
};

/**

* @param {Kiotviet_Link_Relink_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_relink_confirm = /** @type {((inputs: Kiotviet_Link_Relink_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_Relink_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_relink_confirm(inputs)
});